'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

var _options = require('../common/options');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PieComponent = function (_BaseComponent) {
    (0, _inherits3.default)(PieComponent, _BaseComponent);

    function PieComponent(props) {
        (0, _classCallCheck3.default)(this, PieComponent);
        return (0, _possibleConstructorReturn3.default)(this, (PieComponent.__proto__ || (0, _getPrototypeOf2.default)(PieComponent)).call(this, props));
    }

    /**
     * 矫正 option
     */


    (0, _createClass3.default)(PieComponent, [{
        key: 'packageOption',
        value: function packageOption() {
            var _this2 = this;

            var option = JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _options.PieOption)));
            var _props = this.props,
                type = _props.type,
                color = _props.color,
                title = _props.title,
                subTitle = _props.subTitle,
                _props$titleX = _props.titleX,
                titleX = _props$titleX === undefined ? 'center' : _props$titleX,
                _props$orient = _props.orient,
                orient = _props$orient === undefined ? 'vertical' : _props$orient,
                _props$legendY = _props.legendY,
                legendY = _props$legendY === undefined ? 'auto' : _props$legendY,
                _props$legendX = _props.legendX,
                legendX = _props$legendX === undefined ? 'left' : _props$legendX,
                hasLegend = _props.hasLegend,
                hasToolbox = _props.hasToolbox,
                hasTooltip = _props.hasTooltip,
                animation = _props.animation,
                data = _props.data;

            var legendData = [];
            var series = [];
            if (color && color.length) {
                option.color = color;
            }
            option.title.text = title;
            option.title.subtext = subTitle;
            option.title.x = titleX;
            option.tooltip.show = hasTooltip;
            option.legend.show = hasLegend;
            option.legend.bottom = legendY;
            option.legend.x = legendX;
            option.legend.orient = orient;
            option.toolbox.show = hasToolbox;
            option.animation = animation;

            // 设置 series
            if (Object.prototype.toString.call(data) === '[object Array]' && data.length) {
                data.forEach(function (obj) {
                    _this2.collectionSeries(obj, series, legendData);
                });
            } else if (Object.prototype.toString.call(data) === '[object Object]') {
                this.collectionSeries(data, series, legendData);
            }
            option.legend.data = legendData;
            option.series = series;

            return option;
        }

        /**
         * 
         * 收集 series
         */

    }, {
        key: 'collectionSeries',
        value: function collectionSeries(data, series, legendData) {
            var _props2 = this.props,
                type = _props2.type,
                radius = _props2.radius,
                center = _props2.center,
                roseType = _props2.roseType,
                labelSize = _props2.labelSize;

            var option = null;
            var yData = data.data || [];
            yData.forEach(function (item) {
                legendData.push(item.name);
            });
            if (type === 'ring') {
                option = {
                    type: 'pie',
                    radius: radius || ['50%', '70%'],
                    center: center || ['50%', '50%'],
                    roseType: roseType,
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                fontSize: labelSize || '30',
                                fontWeight: 'bold'
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false
                        }
                    }
                };
            } else {
                option = {
                    type: 'pie',
                    radius: radius || '55%',
                    center: center || ['50%', '50%'],
                    roseType: roseType,
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                };
            }
            series.push((0, _assign2.default)({}, option, data));
        }
    }]);
    return PieComponent;
}(_Base2.default);

exports.default = PieComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/Pie.js
// module id = 606
// module chunks = 0